import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/doceditor/src/app/global-error.tsx");
